function sluglify(text) {
  // Reemplazar caracteres especiales y tildes
  const normalizedText = text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

  return normalizedText
    .toString()
    .toLowerCase()
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace(/[^\w-]+/g, "") // Remove all non-word chars (including _)
    .replace(/-+/g, "-") // Replace multiple - with single -
    .replace(/^-+|-+$/g, ""); // Trim - from start and end of text
}

export default {
  sluglify
}
